import { createFileRoute, Link } from '@tanstack/react-router'
import { Button, Result } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/not-verified')({
    component: VerifyComponent,
})

function VerifyComponent() {
    const { t } = useTranslation()

    return (
        <Result
            className="my-24"
            title={t('Failed to verify')}
            subTitle={t('Most likely you have already use this link before')}
            status="error"
            extra={
                <Link to="/login">
                    <Button
                        size="large"
                        type="primary"
                    >
                        {t('Back to login')}
                    </Button>
                </Link>
            }
        />
    )
}
